import {
    blenderCaseModels,
    iCaseComponentsResultItem,
    iDrawerSeparatorResultItem,
    tBlenderCaseModel,
} from '@/Interfaces/caseComponentsLib';
import { iStoreCaseConfiguration } from '@/Interfaces/storeCaseConfiguration';
import { itemBoxHolder } from '@/Constants/itemBoxHolder';

export function parseConfigStringToJSON(input: string):Array<iCaseComponentsResultItem>|[] {
    const parts = input?.split('|');
    const result:Array<iCaseComponentsResultItem>|[] = [];

    if (!parts) return result;
    // console.log('parts', parts);
    let components, idGroup;
    for (const part of parts) {
        components = part.split('/');
        idGroup = part.split('id');
        if (!part.length || !components[0] || blenderCaseModels.includes(part as tBlenderCaseModel)) continue;
        const item: iCaseComponentsResultItem = {
            id: crypto.randomUUID(),
            prototypeId: components[0],
            isLeft: components[1] === 'true',
        };
        if (idGroup !== undefined) item.idGroup = parseInt(idGroup[1]);
        if (components[2] !== undefined) item.indexPositionY = parseInt(components[2]);
        if (components[3] !== undefined) item.indexPositionX = parseInt(components[3]);
        // @ts-ignore
        result.push(item);
    }

    return result;
}

export function parseToolChestStringToJSON(input: string): iStoreCaseConfiguration {
    const parts = input.split('|');
    const result: iStoreCaseConfiguration = {};
    for (const part of parts) {
        if (!part.length) continue;
        if (part.includes('bn')) result.blenderName = part.split('bn')[1] as tBlenderCaseModel;
        if (part.includes('clrFrame')) result.colorFrame = '#' + (part.split('clrFrame')[1]);
        if (part.includes('clrFace')) result.colorFace = '#' + part.split('clrFace')[1];
        if (part.includes('drClose')) result.isCloseDoors = (part.split('drClose')[1] === 'true') as boolean;
    }

    result.expandedDrawersPrototypeId = parseExpandedDrawersPrototypeId(input.split('exDPrId')[1]);
    result.drawerSeparators = parseDrawerSeparators(input.split('dS')[1]);
    return result;
}

export function parseDrawerSeparators(drS) {
    drS = drS?.split('||')[0];
    const parts = drS?.split('|');
    const result = [];
    if (!parts) return result;
    let item: iDrawerSeparatorResultItem, components;
    for (const part of parts) {
        if (!part.length) continue;

        components = part.split('/');
        item = {
            prototypeId: components[0],
            drawerPrototypeId: components[1],
            count: components[2],
        };
        result.push(item);
    }

    return result;
}

export function parseExpandedDrawersPrototypeId(exDPrIds) {
    exDPrIds = exDPrIds?.split('||')[0];
    const parts = exDPrIds?.split('|');
    const result = [];
    if (!parts) return result;
    for (const part of parts) {
        if (!part.length) continue;
        result.push(part);
    }
    // console.log('exDPrIds', exDPrIds, result);
    return result;
}